import React from 'react';
import PropTypes from 'prop-types';
import { ItemLabelWraper, ItemValueWrapper } from '../styled';
import { floor, isNumber } from 'lodash';
import { convertISOToUTCDateFormat } from '../../../../util/timezone';

const HorizontalLabelItem = ({ itemName, itemLabel, itemValue }) => {
  let val = '-';

  if (itemValue) {
    if (itemName === 'dobOrIncorporationDate' || itemName === 'idExpiryDate') {
      val = convertISOToUTCDateFormat(itemValue);
    } else {
      val = isNumber(itemValue) ? floor(itemValue, 2) : itemValue;
    }
  }

  return (
    <>
      <ItemLabelWraper span="12">{itemLabel}</ItemLabelWraper>
      <ItemValueWrapper span="12">{val}</ItemValueWrapper>
    </>
  );
};

HorizontalLabelItem.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default HorizontalLabelItem;
